import AccountCredit from 'components/FrictionlessCheckout/Payment/PaymentMethodList/AccountCredit/AccountCredit';

export default AccountCredit;
